import React from 'react';
import StatusBadge from './components/StatusBadge';
import ActionCellHeader from './components/ActionCellHeader';
import { UI_CONSTANTS } from './constants';

interface ConnectionStatusRowProps {
  qboConnectionStatus: 'checking' | 'connected' | 'disconnected' | 'error';
  qboTokenInfo: any;
  qboConnectionData: any;
}

const ConnectionStatusRow: React.FC<ConnectionStatusRowProps> = ({ qboConnectionStatus, qboTokenInfo, qboConnectionData }) => {
  const getStatus = () => {
    switch (qboConnectionStatus) {
      case 'connected': return 'both'; // Connected means both systems are working
      case 'disconnected':
      case 'error': return 'error';
      case 'checking': return 'loading';
      default: return 'ready';
    }
  };

  const getStatusText = () => {
    switch (qboConnectionStatus) {
      case 'connected': return 'Connected';
      case 'disconnected': return 'Disconnected';
      case 'error': return 'Error';
      case 'checking': return 'Loading';
      default: return 'Ready';
    }
  };

  return (
    <tr>
      <td className="border border-gray-300 px-3 py-2 font-medium">1. Token Connection</td>
      <td className="border border-gray-300 px-3 py-2 relative">
        <ActionCellHeader description="Checks QuickBooks Online API connection status and retrieves company information including token expiration details." />
        <div className="text-sm">Check QBO API connection</div>
      </td>
      <td className="border border-gray-300 px-3 py-2">
        <div className="font-mono text-xs">
          {qboTokenInfo ? (
            <>
              <div>Expires: {qboTokenInfo.expiresAt ? new Date(qboTokenInfo.expiresAt).toLocaleDateString() : 'N/A'}</div>
              <div>Realm: {qboTokenInfo.realmId || 'N/A'}</div>
            </>
          ) : (
            <div className="text-gray-500">Loading...</div>
          )}
        </div>
      </td>
      <td className="border border-gray-300 px-3 py-2">
        <div className="font-mono text-xs">
          {qboConnectionData ? (
            <>
              <div>Company: {qboConnectionData.companyName || 'N/A'}</div>
              <div>ID: {qboConnectionData.companyId || 'N/A'}</div>
              <div>Status: {qboConnectionStatus}</div>
            </>
          ) : (
            <div className="text-gray-500">Loading...</div>
          )}
        </div>
      </td>
      <td className="border border-gray-300 px-3 py-2">
        <div className="font-mono text-xs text-gray-600">
          {qboConnectionData ? (
            <>
              <div>Environment: Sandbox</div>
              <div>API: Connected</div>
              <div>Last Ping: {new Date().toLocaleTimeString()}</div>
            </>
          ) : (
            <div className="text-gray-500">-</div>
          )}
        </div>
      </td>
      <td className="border border-gray-300 px-2 py-2 text-center">
        <StatusBadge status={getStatus()} text={getStatusText()} />
      </td>
      <td className="border border-gray-300 px-3 py-2">
        <div className="text-gray-500 text-xs">-</div>
      </td>
      <td className="border border-gray-300 px-3 py-2">
        <div className="text-gray-500 text-xs">-</div>
      </td>
    </tr>
  );
};

export default ConnectionStatusRow;
